<template>
  <div>
    <el-tabs type="border-card"
             @tab-click="tabclick">
      <el-tab-pane label="账户信息"> </el-tab-pane>
      <el-tab-pane label="所属县排名"> </el-tab-pane>
      <el-tab-pane label="本地区（市）单位排名"> </el-tab-pane>
      <el-tab-pane label="本地区（市）人员排名"> </el-tab-pane>
      <el-tab-pane label="本单位人员排名"> </el-tab-pane>
      <el-tab-pane label="排行榜"
                   name="phb"> </el-tab-pane>
      <el-tab-pane label="单位标签管理"
                   name="tags"> </el-tab-pane>
      <el-tab-pane label="审核人员" name='change'> </el-tab-pane>
    </el-tabs>
    <div class="content-wrap">
      <user-info :dwform="dwform"
                 v-show="zhxxisshow"></user-info>
      <tags v-if="currentTab=='tab-tags'" />
      <examinePeople v-if="currentTab=='tab-change'"/>
      <div v-show="tableisshow">
        <div class="header"
             style="align-items: center">
          <export-data :selectdata="tableData"
                       :Field="this.dataField"
                       :dwform="this.dwform"
                       :isout="this.isout"></export-data>
          <search-input class="search"
                        ref="search"
                        :getname="getname"
                        v-show="searchisshow"></search-input>
          <el-select v-if="currentTab == 'tab-4'"
                     v-model="tag"
                     placeholder="请选择"
                     size="mini"
                     clearable
                     style="height: 100%"
                     @change="queryBzTable">
            <el-option v-for="item in tags"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </div>
        <el-table :row-style="{ height: '36px' }"
          :cell-style="{ padding: '0px' }"
          :header-row-style="{ height: '20px' }"
          :header-cell-style="{
            background: '#eef1f6',
            padding: '6px 0',
          }"
          style="width: 100%; color: #606266"
          ref="multipleTable5"
          :data="tableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          tooltip-effect="dark"
          :height="clientHeight"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="55"> </el-table-column>
          <el-table-column v-for="(item, index) in currentcloumn.title"
                           :key="index"
                           :prop="currentcloumn.enname[index]"
                           :label="item"
                           :sort-method="
              (a, b) => {
                return a[item.props] - b[item.props];
              }
            ">
          </el-table-column>
        </el-table>
        <pagi-nation :Count="Count"
                     @size-change="handleSizeChange"
                     @current-change="onCurrentChange"
                     ref="pagination"
                     v-show="pagiisshow"></pagi-nation>
      </div>
      <div>
        <phb-table v-show="phpisshow"></phb-table>
      </div>
    </div>
  </div>
</template>

<script>
import phbTable from "@/components/phbTable";
import pagiNation from "@/components/pagiNation";
import examinePeople from"@/components/examinePeople.vue"
import exportData from "@/components/exportData";
import userInfo from "@/components/userInfo.vue";
import searchInput from "@/components/searchInput";
import { getlist, getssxb2, getdwb2, getcitylist } from "@/utils/request";
import tags from "./tags.vue";
export default {
  components: { phbTable, pagiNation, exportData, userInfo, searchInput, tags,examinePeople },
  data () {
    return {
      loading: false,
      dwform: {},
      Count: 0,
      currentPage: 1,
      PageSize: 15,
      selecttableData: [],
      currentTab: "",
      currenttable: {},
      name: "",
      tag: "",
      tags: [],
      sss: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["dist", "score", "bdqpm"],
      },
      department: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["department", "score", "bdqpm"],
      },
      bdqdw: {
        title: ["姓名", "单位", "竞赛分", "年度分", "本地区排名"],
        enname: ["name", "department", "score", "score_2023", "bdqpm"],
      },
      sss1: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["dist", "score", "bdqpm"],
      },
      department1: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["department", "score", "bdqpm"],
      },
      bdqdw1: {
        title: ["姓名", "单位", "标签", "五进人员类型", "竞赛分", "年度分", "本单位排名"],
        enname: ["name", "department", "tag", "wjlb", "score", "score_2023", "bdqpm"],
      },
      sss2: {
        title: ["名称", "总分"],
        enname: ["dist", "score"],
      },
      department2: {
        title: ["名称", "总分"],
        enname: ["department", "score"],
      },
      bdqdw2: {
        title: ["姓名", "单位", "竞赛分", "年度分"],
        enname: ["name", "department", "score", "score_2023"],
      },
      tableData: [],
    };
  },
  methods: {
    queryBzTable () {
      console.log("请求了数据");
      this.loading = true;
      //debugger
      this.tableData = [];
      //请求表格数据
      /*       this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getMemberList', {
              params: { "pageNo": this.currentPage, "pageNum": this.PageSize, "department": this.dwform.department },
      
            }).then(res => {
              console.log(res.data);
              this.tableData = res.data.datalist;
              this.Count = res.data.total;
              this.loading = false;
            }); */
      return getlist(
        this.currentPage,
        this.PageSize,
        this.dwform.department,
        this.name,
        this.tag
      ).then((res) => {
        this.loading = false;
        console.log(res.data);
        this.tableData = res.data.datalist;
        if (this.tableData !== undefined) {
          this.tableData.forEach((v, index) => {
            v.bdqpm = index + 1 + this.PageSize * (this.currentPage - 1);
          });
        }
        this.Count = res.data.total;
      });
    },
    querycityTable () {
      console.log("请求了数据");
      this.loading = true;
      //debugger
      this.tableData = [];
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getMemberList', {
        params: { "pageNo": this.currentPage, "pageNum": this.PageSize, "region": this.dwform.region, city: this.dwform.city }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.datalist;
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getcitylist(
        this.currentPage,
        this.PageSize,
        this.dwform.region,
        this.dwform.city,
        this.name
      ).then((res) => {
        this.loading = false;
        console.log(res.data);
        this.tableData = res.data.datalist;
        if (this.tableData !== undefined) {
          this.tableData.forEach((v, index) => {
            v.bdqpm = index + 1 + this.PageSize * (this.currentPage - 1);
          });
        }
        this.Count = res.data.total;
      });
    },
    querydist () {
      console.log("请求了数据");
      this.loading = true;
      //debugger
      this.tableData = [];
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getrank&showtype=10&department', {
        params: {  "region": this.dwform.region, city: this.dwform.city }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v,index) => {
          v.bdqpm=index+1
        });
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getssxb2(this.dwform.region, this.dwform.city).then((res) => {
        this.loading = false;
        console.log(res.data);
        this.tableData = res.data.data;
        if (this.tableData !== undefined) {
          this.tableData.forEach((v, index) => {
            v.bdqpm = index + 1;
          });
        }
        this.Count = res.data.total;
      });
    },
    querydepartment () {
      console.log("请求了数据");
      this.loading = true;
      //debugger
      this.tableData = [];
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getrank&showtype=2&department', {
        params: { "region": this.dwform.region, city: this.dwform.city }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.bdqpm = index + 1
        });
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getdwb2(this.dwform.region, this.dwform.city, this.name).then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.bdqpm = index + 1;
            });
          }
          this.Count = res.data.total;
        }
      );
    },
    handleSizeChange (e) {
      console.log("分页器数值改变", e);
      this.PageSize = e;
      if (this.currentTab == "tab-3") {
        this.querycityTable();
      }
      if (this.currentTab == "tab-4") {
        this.queryBzTable();
      }
    },
    onCurrentChange (e) {
      console.log("当前页数值变化", e);
      this.currentPage = e;
      if (this.currentTab == "tab-3") {
        this.querycityTable();
      }
      if (this.currentTab == "tab-4") {
        this.queryBzTable();
      }
    },
    handleSelectionChange (selection) {
      this.selecttableData = selection.map((val) => {
        return val;
      });
      console.log(this.selecttableData);
    },
    tabclick (tab, event) {
      this.$refs.search.clear();
      this.name = "";
      this.sss = this.sss1;
      this.department = this.department1;
      this.bdqdw = this.bdqdw1;
      this.selecttableData = [];
      this.currentTab = event.target.getAttribute("id");
      this.currentPage = 1;
      this.PageSize = 15;
      console.log(this.dataField);
      this.$refs.pagination.tbclick();
      switch (this.currentTab) {
        case "tab-1":
          this.querydist();
          break;
        case "tab-2":
          this.querydepartment();
          break;
        case "tab-3":
          this.querycityTable();
          break;
        case "tab-4":
          this.queryBzTable();
          break;
        case "tab-tags":
          /* this.queryBzTable(); */
          break;
        default:
          this.queryBzTable();
          break;
      }
    },
    search () {
      if (this.name == "") {
        this.sss = this.sss1;
        this.department = this.department1;
        this.bdqdw = this.bdqdw1;
      } else {
        this.sss = this.sss2;
        this.department = this.department2;
        this.bdqdw = this.bdqdw1;
      }
      switch (this.currentTab) {
        case "tab-4":
          this.queryBzTable();
          break;
        case "tab-3":
          this.querycityTable();
          break;
        case "tab-2":
          this.querydepartment();
          break;
        default:
          break;
      }
    },
    getname (name) {
      this.name = name;
    },
    getTags () {
      let dataId = JSON.parse(window.localStorage.getItem("dwform")).dataId;
      let params = {
        dataId: dataId,
      };
      this.$http({
        method: "get",
        url: this.$Api.getTags,
        params,
      })
        .then((result) => {
          console.log("result :>> ", result);
          let res = result.data.tags;
          if (res !== "") {
            this.tags = res.split(",");
          }
        })
        .catch((err) => { });
    },
  },
  created () {
    let that = this;
    that.clientHeight = document.documentElement.clientHeight - 270;
    window.onresize = () => {
      that.clientHeight = document.documentElement.clientHeight - 270;
    };
    this.dwform = JSON.parse(localStorage.getItem("dwform"));
    this.getTags();
  },
  computed: {
    searchisshow () {
      switch (this.currentTab) {
        case "tab-1":
          return false;
        default:
          return true;
      }
    },
    dataField () {
      switch (this.currentTab) {
        case "tab-1":
          return this.sss;
        case "tab-2":
          return this.department;
        case "tab-3":
          return this.bdqdw;
        case "tab-4":
          return this.bdqdw;
        default:
          return 0;
      }
    },
    zhxxisshow () {
      if (this.currentTab == "" || this.currentTab == "tab-0") {
        return true;
      } else {
        return false;
      }
    },
    isout () {
      switch (this.currentTab) {
        case "tab-3":
          return true;
        case "tab-4":
          return "dw";
        default:
          return false;
      }
    },
    tableisshow () {
      switch (this.currentTab) {
        case "":
          return false;
        case "tab-0":
          return false;
        case "tab-phb":
          return false;
        case "tab-tags":
          return false;
        case "tab-change":
          return false;
        default:
          return true;
      }
    },
    currentcloumn () {
      switch (this.currentTab) {
        case "tab-1":
          return this.sss;
        case "tab-2":
          return this.department;
        case "tab-3":
          return this.bdqdw;
        case "tab-4":
          return this.bdqdw;
        default:
          return "";
      }
    },
    phpisshow () {
      if (this.currentTab == "tab-phb") {
        return true;
      } else {
        return false;
      }
    },
    pagiisshow () {
      switch (this.currentTab) {
        case "tab-3":
          return true;
        case "tab-4":
          return true;
        default:
          return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-table {
  width: 99.9% !important;
}
.content-wrap {
  border: 1px solid #dcdfe6;
  border-top: none;
}
.el-tabs--border-card {
  box-shadow: none !important;
}
</style>